const FIELD_LABELS = {
  username: 'Username',
  password: 'Password',
  email: 'Email address',
  phone: 'Mobile number',
  referral_code_used: 'Referral code',
};

export function getApiErrorMessage(data, fallback = 'Something went wrong.') {
  if (!data) return fallback;
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) return fallback;
    if (/^\s*<!doctype html/i.test(trimmed) || /^\s*<html/i.test(trimmed)) {
      return fallback;
    }
    return trimmed;
  }
  if (typeof data.message === 'string' && data.message.trim()) return data.message;
  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
  if (Array.isArray(data.detail) && data.detail.length) {
    return data.detail.map((v) => String(v)).join(' ');
  }
  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error === 'upload_server_error' ? fallback : data.error;
  }
  if (typeof data === 'object') {
    const flat = Object.values(data)
      .flat()
      .filter((v) => typeof v === 'string' && v.trim());
    if (flat.length) return flat.join(' ');
  }
  return fallback;
}

export function humanizeApiFieldError(field, messages) {
  const label = FIELD_LABELS[field] || field;
  const raw = Array.isArray(messages) ? messages[0] : messages;
  if (typeof raw !== 'string') return String(raw ?? 'Invalid value.');
  if (raw === 'This field may not be blank.' || raw === 'This field is required.') {
    return `${label} is required.`;
  }
  if (raw.toLowerCase().includes('already registered')) {
    return raw;
  }
  return raw;
}

export function parseApiErrors(data) {
  if (!data || typeof data !== 'object') {
    return { form: 'Something went wrong.', fields: {} };
  }
  const fields = {};
  let form = '';
  for (const [key, value] of Object.entries(data)) {
    if (key === 'detail' || key === 'non_field_errors' || key === 'error') {
      const msg = Array.isArray(value) ? value.join(' ') : value;
      if (msg) form = msg;
      continue;
    }
    fields[key] = humanizeApiFieldError(key, value);
  }
  if (!form && Object.keys(fields).length > 1) {
    form = 'Please fix the highlighted fields.';
  }
  return { form, fields };
}

export function isValidMobileOptional(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return true;
  const normalized =
    digits.length > 10 && digits.startsWith('91') ? digits.slice(-10) : digits;
  return normalized.length === 10;
}
